import { Component, OnInit } from '@angular/core';
import { CosasFiltros } from '../../models/cosasFiltros';
import { ProfileService } from '../../services/profile.service';
import { ContentService } from '../../services/content.service';
import { Favorites } from 'src/app/models/Favorites';
import { Schedule } from '../../models/content';
import { LoadDataService } from '../../services/load-data.service';
import { ContentDetails } from '../../models/contentDetails';

@Component({
  selector: 'app-mis-cosas',
  templateUrl: './mis-cosas.page.html',
  styleUrls: ['./mis-cosas.page.scss'],
})
export class MisCosasPage implements OnInit {

  events = true;
  filtro = 'todo';
  
  beEvents = false;

  cardsE: Schedule[] = [];
  cards: Favorites[] = [];

  isLoading = true;

  constructor(
    public loadDataService: LoadDataService,
    private profileService: ProfileService,
    private contentService: ContentService
  ) { }
  
  ngOnInit() {
    // this.getFavorites();
    // this.getSubscriptions();
  }
  
  ionViewWillEnter() {
    // console.log('view');
    this.getFavorites();
    this.getSubscriptions();
  }

  changeThing( state: boolean ) {
    !state ? this.getFavorites() : null;
    this.events = state;
  }

  changeFilter( option: string ){
    this.filtro = option;
  }

  getFavorites() {
    // console.log('?')
    const opt = {
      "profileId": this.profileService.profile.id
    }
    this.contentService.getFavorites( opt )
        .subscribe( (resp:Favorites[]) => {
          console.log( resp )
          this.cards = resp;
          this.isLoading = false;
        })
  }

  getSubscriptions() {
    const opt = {
      "profileId": this.profileService.profile.id
    }
    this.contentService.getSubscribe( opt )
        .subscribe( (resp: Schedule[]) => {
          console.log( resp )
          this.cardsE = resp;
          this.isLoading = false;
        })
  }
}
